function getMessage(field, args) {
  if (args === void 0) args = []
  const incSI = args[1]

  return `The ${field} only accepts increment in blocks of ${incSI}.`
}

function validate(value, args) {
  if (value) {
    if (args === void 0) args = []
    let minSI = args[0]
    let incSI = args[1]
    if (!minSI) {
      minSI = Number(0)
    } else {
      minSI = Number(minSI)
    }
    if (!incSI) {
      return true
    } else {
      value = '' + value // If a format other den str, it doesnt has replace
      const convertVal = Number(value.replace(/,/g, ''))
      if (convertVal > minSI) {
        const remainingVal = convertVal - minSI
        if (remainingVal % incSI > 0) {
          return false
        }
      }
      return true
    }
  } else return true
}

export default {
  getMessage,
  validate
}
